import { Pill } from "PFComponents/pill";
import { Option, OptionOriginal } from "PFTypes/options";
import { SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";
export type RemoveHandler<T> = (value: Option<T>, event: SyntheticEvent) => void;

export type ValueBadgeProps<T> = {
  onRemove: RemoveHandler<T>;
  value: Option<T>;
  disabled?: boolean;
  tabIndex?: number;
};

export const ValueBadge = <T extends OptionOriginal = OptionOriginal>({
  value,
  onRemove,
  disabled,
  tabIndex
}: ValueBadgeProps<T>) => {
  const { t } = useTranslation("core", { keyPrefix: "components.selectV2" });
  const displayValue = value.displayElement || value.value || "";

  return (
    <Pill
      small
      text={displayValue as string}
      style={typeof displayValue === "object" ? { height: "fit-content" } : {}}
      {...(!disabled
        ? {
            deleteTitle: t("removeOption", {
              label: displayValue
            }),
            onDelete: (e) => onRemove(value, e),
            onDeleteKeyDown: (e) => e.stopPropagation(),
            tabIndex
          }
        : {})}
    />
  );
};
